module.exports = __webpack_public_path__ + "static/media/footer_insta.c0789253.svg";